/* ZOOPLICITY Playful Paki v10 — per-item extended prices */
window.ZP_PAKI_BOOT = function(){'use strict';
const root=document.querySelector('[data-zp-paki-lab-app]');
const original=window.ZP_PAKI_CATALOG;
if(!root||!original?.packs||root.__zpPakiReady)return;
root.__zpPakiReady=true;
const data=JSON.parse(JSON.stringify(original)),images={...(window.ZP_PAKI_PHOTOS||{})};
const dict=data.catalog,packs=data.packs;
for(const [sku,p] of Object.entries(window.ZP_PAKI_EXTRA_CATALOG||{})){
 if(!dict[sku]&&p?.handle&&p?.sku===sku){dict[sku]=p;if(p._image)images[sku]=p._image;}
}

const texts=window.ZP_PAKI_TEXTS||{},legacy=window.ZP_PAKI_COPY||{};
const fmt=v=>new Intl.NumberFormat('pl-PL',{style:'currency',currency:'PLN'}).format(Number(v)||0);
const shopRoot=(window.Shopify?.routes?.root||'/').replace(/\/?$/,'/');
const savedKey='zp-paki-premium-picks-v4';
let saved={};try{saved=JSON.parse(sessionStorage.getItem(savedKey)||'{}')||{}}catch(_){}
const names={'dog-5':'Smakowa Paka · pies','cat-5':'Smakowa Paka · kot','dog-toys':'Paka Zabawek · pies','cat-toys':'Paka Zabawek · kot'};
const hints={'dog-adopt':'Przygotuj wspólnie wyprawkę na nowy dom','cat-adopt':'Przygotuj wszystko na pierwszy wspólny dzień','puppy-month':'Pierwsze tygodnie, mnóstwo odkryć','dog-5':'Smaki na wspólne chwile','cat-5':'Smaki, które Twój kot wybierze sam','dog-winter':'Spacery mimo deszczu'};
for(const p of packs){
 const edit={...(legacy.packs?.[p.key]||{}),...(texts.packs?.[p.key]||{})};
 if(edit.title)p.title=edit.title;
 if(edit.tagline)p.tagline=edit.tagline;
 if(edit.slots?.trim?.())edit.slots.split(/\r?\n/).forEach((v,i)=>{if(v.trim()&&p.slots[i])p.slots[i].title=v.trim()});
 if(edit.checklist?.trim?.())edit.checklist.split(/\r?\n/).forEach((v,i)=>{if(v.trim()&&p.checklist?.[i])p.checklist[i].text=v.trim()});
 p.showName=names[p.key]||p.title;
}
if(texts.global?.product_labels?.trim?.())texts.global.product_labels.split(/\r?\n/).forEach(line=>{
 const i=line.indexOf('|');if(i<1)return;const sku=line.slice(0,i).trim();if(dict[sku])dict[sku].name=line.slice(i+1).trim()||dict[sku].name;
});

const merchant=window.ZP_PAKI_EDITOR||{};
if(merchant.labels?.trim?.())merchant.labels.split(/\r?\n/).forEach(line=>{
 const index=line.indexOf('|');if(index<1)return;const sku=line.slice(0,index).trim(),name=line.slice(index+1).trim();
 if(dict[sku]&&name)dict[sku].name=name;
});
for(const block of merchant.overrides||[]){
 const p=packs.find(x=>x.key===block.key);
 if(!p)continue;
 if(block.title?.trim?.())p.showName=block.title.trim();
 if(block.tagline?.trim?.())p.tagline=block.tagline.trim();
 if(block.cover?.trim?.())p._cover=block.cover.trim();
 if(block.rules?.trim?.())block.rules.split(/\r?\n/).forEach(line=>{
  const index=line.indexOf('=');if(index<1)return;
  let category=line.slice(0,index).trim(),extra=category.startsWith('+');
  if(extra)category=category.slice(1).trim();
  if(!category)return;
  const safe=[...new Set(line.slice(index+1).split(/[,;\s]+/).map(s=>s.trim()).filter(s=>dict[s]&&dict[s]._shopifyStatus!=='DRAFT'))];
  if(!safe.length)return;
  const matching=p.slots.find(s=>s.title.toLocaleLowerCase('pl-PL')===category.toLocaleLowerCase('pl-PL'));
  if(matching){matching.options=safe;if(!safe.includes(matching.default))matching.default=safe[0]}
  else if(extra)p.slots.push({title:category,options:safe,default:safe[0],optional:true,min:0,max:3,defaultQty:0});
 });

  if(block.categoryNames?.trim?.())block.categoryNames.split(/\r?\n/).forEach(line=>{
   const i=line.indexOf('|');if(i<1)return;
   const original=line.slice(0,i).trim(),replacement=line.slice(i+1).trim();
   const slot=p.slots.find(s=>s.title===original);
   if(slot&&replacement)slot.title=replacement;
  });
  if(block.checklist?.trim?.()&&p.checklist?.length){
   block.checklist.split(/\r?\n/).forEach(line=>{
    const i=line.indexOf('|');if(i<1)return;
    const index=Number(line.slice(0,i).trim())-1,phrase=line.slice(i+1).trim();
    if(Number.isInteger(index)&&index>=0&&index<p.checklist.length&&phrase)p.checklist[index].text=phrase;
   });
  }
}
const uiDefaults={"pageEyebrow":"ZOOPLICITY · PRACOWNIA PAK","dogTab":"🐕 Dla psa","catTab":"🐈 Dla kota","packFallback":"Skomponuj po swojemu","boardEyebrow":"TWOJA WŁASNA PAKA","boardHint":"Kliknij zdjęcie, żeby podejrzeć produkt. Zmieniaj i dorzucaj bez przechodzenia przez kroki.","addonsEyebrow":"DORZUĆ DO PAKI","addonsTitle":"Co jeszcze zabieramy?","addonsHelp":"Dodaj opcjonalne rzeczy lub uzupełnij brakującą kategorię. W „Zmień lub dodaj” dołożysz też różne produkty.","filterCaption":"Szybki wybór","filterAll":"Wszystko","filterFood":"Smakołyki i karma","filterPlay":"Zabawki","filterWalk":"Spacer","filterSleep":"Odpoczynek","filterCare":"Higiena","filterOther":"Pozostałe","previewAction":"↗ Podgląd","swapAction":"Zmień lub dodaj +","addAction":"+ Dodaj do paki","removeAction":"Usuń","unitPrice":"Za 1 szt.: ","totalLabel":"Łącznie za całą pakę","buyLabel":"Dodaj całą pakę do koszyka →","footerInfo":"Produkty trafią osobno do koszyka Shopify. Bez automatycznej subskrypcji.","checklistTitle":"Przydatna lista przed przyjazdem pupila","emptyBoard":"Twoja paka czeka na pierwsze produkty.","previewTitle":"Podgląd produktu","available":"✓ Dostępny","unavailable":"Niedostępny","loading":"Sprawdzam dostępność…","fullDescription":"Pełny opis ↗","previewSelect":"Zmień lub dodaj produkty","chooserPrefix":"Zmień lub dodaj: ","chooserHelp":"Dodaj kilka różnych produktów, zamień obecny albo usuń go z paki. Bez przechodzenia przez kroki.","chosenHeading":"Już w Twojej pace","chosenEmpty":"Jeszcze nic — wybierz z listy poniżej.","chosenLimits":"Maksymalnie {different} różnych produktów w kategorii i {pieces} szt. każdego. Kwoty są liczone za wybrane ilości.","chooserAdd":"Dodaj do paki +","chooserAnother":"Dodaj kolejny +","chooserLimit":"Limit ilości","chooserCurrent":"Ten produkt","chooserReplace":"Zamień","chooserDone":"Gotowe — wróć do paki","chooserFamily":"Produkty","chooserChecking":"Sprawdzam dostępność…","chooserUnavailable":"Niedostępny produkt. Wybierz inny.","chooserMax":"Osiągnięto limit w tej kategorii.","chooserReplaced":"Zamieniono. Możesz dodać kolejne produkty.","chooserAdded":"Dodano! Możesz wybrać coś jeszcze.","cartBusy":"Dodaję produkty…","cartChecking":"Sprawdzam dostępność…","cartUnavailable":"Zmień niedostępne produkty","cartInvalid":"Popraw ilości","cartRequired":"Wybierz po jednym produkcie w obowiązkowych kategoriach.","itemUnavailable":"Niedostępny — zmień lub usuń","cartOutOfStock":"Zmień niedostępne produkty: ","cartError":"Nie udało się dodać produktów","sizeHint":"Pokazujemy tylko rozmiary i produkty dostępne do zamówienia.","sizeAvailable":"Dostępny","sizeUnavailable":"Brak na stanie","sizeChecking":"Sprawdzam…","sizeOnlyAvailable":"Pokaż tylko dostępne"};
const ui={...uiDefaults,...Object.fromEntries(Object.entries(merchant.ui||{}).filter(([k,v])=>Object.prototype.hasOwnProperty.call(uiDefaults,k)&&typeof v==='string'&&v.trim()).map(([k,v])=>[k,v]))};
const u=key=>ui[key]||uiDefaults[key];
const interpolate=(template,vars)=>template.replace(/\{(\w+)\}/g,(_,k)=>String(vars[k]??''));
const startKey=decodeURIComponent(location.hash.replace('#',''));
let key=packs.some(p=>p.key===startKey)?startKey:'dog-adopt',species=packs.find(p=>p.key===key)?.species||'pies';
const current=()=>packs.find(p=>p.key===key)||packs[0];
let modal=null,notice='',busy=false,detailsOpen=false,activeFilter='all';
const node=(tag,cls,txt)=>{const n=document.createElement(tag);if(cls)n.className=cls;if(txt!==undefined)n.textContent=txt;return n};
const btn=(txt,cls,fn)=>{const b=node('button',cls,txt);b.type='button';b.onclick=fn;return b};

const multiLimit=8,perProductLimit=5;
function choices(p,i){
 const slot=p.slots[i],raw=saved[p.key]?.[i];
 let all;
 if(Array.isArray(raw?.items))all=raw.items;
 else if(Array.isArray(raw))all=raw;
 else if(raw!==null&&raw!==undefined)all=[typeof raw==='string'?{sku:raw,qty:1}:raw];
 else all=[{sku:slot.default,qty:Number(slot.defaultQty??(slot.optional?0:1))}];
 const chosen=new Map();
 for(const item of all){
  if(!item||!slot.options.includes(item.sku)||!dict[item.sku])continue;
  const currentVariant=dict[item.sku];
  if(currentVariant._live&&!currentVariant._available)continue;
  if(!currentVariant._live&&currentVariant._availableFromAudit===false)continue;
  const qty=Math.max(0,Math.min(perProductLimit,Math.round(Number(item.qty)||0)));
  if(qty>0)chosen.set(item.sku,Math.min(perProductLimit,(chosen.get(item.sku)||0)+qty));
 }
 return [...chosen].slice(0,multiLimit).map(([sku,qty])=>({sku,qty}));
}
const state=(p,i)=>choices(p,i)[0]||{sku:p.slots[i].default,qty:0};
const picks=p=>p.slots.flatMap((slot,i)=>choices(p,i).map(x=>({...x,i,slot})));
const total=p=>picks(p).reduce((sum,x)=>sum+x.qty*(dict[x.sku]?.price||0),0);
const exactProblem=p=>p.slots.some((s,i)=>!s.optional&&choices(p,i).length===0)?u('cartRequired'):'';
function persist(p,i,list){
 const next=p.slots.map((slot,j)=>({items:j===i?list.filter(x=>x.qty>0&&slot.options.includes(x.sku)).slice(0,multiLimit).map(x=>({sku:x.sku,qty:Math.max(1,Math.min(perProductLimit,Math.round(Number(x.qty)||1)))})):choices(p,j)}));
 saved[p.key]=next;
 try{sessionStorage.setItem(savedKey,JSON.stringify(saved))}catch(_){}
 notice='';draw();syncCurrent();
}
function alterQty(p,i,sku,delta){
 const list=choices(p,i).map(x=>({...x})),item=list.find(x=>x.sku===sku);
 if(!item)return;
 item.qty=Math.max(0,Math.min(perProductLimit,item.qty+delta));
 persist(p,i,list);
}
function addChoice(p,i,sku,mode='add',oldSku=null){
 if(!p.slots[i].options.includes(sku)||!dict[sku])return false;
 let list=choices(p,i).map(x=>({...x}));
 if(mode==='replace'&&oldSku&&oldSku!==sku){
  const index=list.findIndex(x=>x.sku===oldSku),prior=index>=0?list.splice(index,1)[0]:{qty:1};
  const same=list.find(x=>x.sku===sku);
  if(same)same.qty=Math.min(perProductLimit,same.qty+prior.qty);
  else list.splice(Math.max(index,0),0,{sku,qty:prior.qty});
 }else if(mode==='replace'&&oldSku===sku)return true;
 else{
  const found=list.find(x=>x.sku===sku);
  if(found){if(found.qty>=perProductLimit)return false;found.qty++}
  else {if(list.length>=multiLimit)return false;list.push({sku,qty:1})}
 }
 persist(p,i,list);return true;
}
function image(sku,cls){
 const n=node('span',cls),src=images[sku]||dict[sku]?._image;
 if(src){const el=node('img');el.src=src;el.alt=dict[sku]?.name||'Produkt';el.loading='lazy';el.onerror=()=>n.replaceChildren(node('span','zp-game-noimg','🐾'));n.append(el)}
 else n.append(node('span','zp-game-noimg','🐾'));
 return n;
}
const requests=new Map();
async function loadSku(sku,force=false){
 const d=dict[sku];if(!d)return null;
 if(force)requests.delete(sku);
 if(!force&&d._live)return d;
 if(requests.has(sku))return requests.get(sku);
 const work=(async()=>{
  try{
   if(!d.handle)throw Error('Produkt nie ma adresu w Shopify');
   const response=await fetch(shopRoot+'products/'+encodeURIComponent(d.handle)+'.js',{credentials:'same-origin'});
   if(!response.ok)throw Error('Produkt nie jest dostępny w sklepie');
   const p=await response.json(),v=p.variants?.find(x=>x.sku===sku);
   if(!v)throw Error('Brak wariantu SKU');
   d.variantId=Number(v.id);d.price=Number(v.price)/100;d._available=Boolean(v.available)&&!Boolean(v.requires_selling_plan||p.requires_selling_plan);
   d._problem=d._available?'':'Wariant niedostępny';
   d._image=v.featured_image?.src||p.featured_image||p.images?.[0]||'';
   d._description=String(p.description||'').replace(/<[^>]+>/g,' ').replace(/&amp;/g,'&').replace(/&nbsp;/g,' ').replace(/\s+/g,' ').trim().slice(0,380);
  }catch(err){d._available=false;d._problem=String(err.message||err)}
  d._live=true;return d;
 })();
 requests.set(sku,work);return work;
}
let loadingSerial=0;
function syncCurrent(){
 const active=current(),which=++loadingSerial,list=[...new Set(picks(active).map(x=>x.sku))];
 Promise.allSettled(list.map(sku=>loadSku(sku))).then(()=>{if(which===loadingSerial&&key===active.key)draw()});
}
function packTile(p){
 const selected=p.key===key,b=btn('', 'zp-game-pack'+(selected?' active':''),()=>{
  if(key===p.key)return;key=p.key;species=p.species;detailsOpen=false;activeFilter='all';notice='';closeModal(false);
  history.replaceState(null,'',location.pathname+location.search+'#'+key);
  draw();syncCurrent();
 });
 b.setAttribute('aria-pressed',String(selected));
 const collage=node('div','zp-game-pack-art');

 if(p._cover){
  const cover=node('img','zp-game-pack-cover');cover.src=p._cover;cover.alt='Paka '+p.showName;cover.loading='lazy';collage.append(cover);
 }else{
  const preferred=p.slots.filter(s=>Number(s.defaultQty??(s.optional?0:1))>0);
  const sources=[...preferred,...p.slots.filter(s=>!preferred.includes(s))];
  const skus=[...new Set(sources.map(s=>s.default))].filter(s=>dict[s]&&(images[s]||dict[s]._image)).slice(0,3);
  skus.forEach((sku,i)=>collage.append(image(sku,'zp-game-pack-photo zp-game-pack-photo-'+i)));
 }

 const text=node('span','zp-game-pack-copy');text.append(node('strong','',p.showName),node('small','',p.tagline||u('packFallback')));
 b.append(collage,text);return b;
}

function productCard(p,entry,position){
 const d=dict[entry.sku],slot=entry.slot;
 const card=node('article','zp-game-product zp-game-tilt-'+(position%7)+(d._live&&!d._available?' is-out':''));
 const photo=btn('','zp-game-photo-button',()=>openPreview(p,entry.i,entry.sku));
 photo.setAttribute('aria-label','Podgląd '+d.name);photo.append(image(entry.sku,'zp-game-product-photo'));
 photo.append(node('span','zp-game-look',u('previewAction')));card.append(photo);
 const label=node('div','zp-game-product-copy');
 label.append(node('small','',slot.title),node('strong','',d.name));card.append(label);
 const bottom=node('div','zp-game-card-bottom');
 const pricing=node('div','zp-game-pricing');pricing.append(node('span','zp-game-unit-price',u('unitPrice')+fmt(d.price)),node('strong','zp-game-product-price',fmt(Math.round(d.price*entry.qty*100)/100)));if(entry.qty>1)pricing.append(node('span','zp-game-price-multiplier',entry.qty+' × '+fmt(d.price)));bottom.append(pricing);
 const counter=node('div','zp-game-counter');
 const minus=btn('−','zp-game-qty-btn',()=>alterQty(p,entry.i,entry.sku,-1));
 minus.disabled=entry.qty<=1;minus.setAttribute('aria-label','Zmniejsz ilość '+d.name);
 const plus=btn('+','zp-game-qty-btn',()=>alterQty(p,entry.i,entry.sku,1));
 plus.disabled=entry.qty>=perProductLimit;plus.setAttribute('aria-label','Zwiększ ilość '+d.name);
 counter.append(minus,node('output','zp-game-qty',String(entry.qty)),plus);
 bottom.append(counter);card.append(bottom);
 if(d._live&&!d._available)card.append(node('p','zp-game-out',u('itemUnavailable')));
 const actions=node('div','zp-game-actions');
 actions.append(btn(u('swapAction'),'zp-game-swap',()=>openChooser(p,entry.i,entry.sku)));
 actions.append(btn(u('removeAction'),'zp-game-remove',()=>persist(p,entry.i,choices(p,entry.i).filter(x=>x.sku!==entry.sku))));
 card.append(actions);return card;
}
function addOnCard(p,i){
 const s=p.slots[i],card=btn('','zp-game-add-tile',()=>openChooser(p,i));
 card.setAttribute('aria-label','Dodaj: '+s.title);
 card.append(image(s.default,'zp-game-addon-img'));
 const desc=node('span','');desc.append(node('strong','',s.title),node('small','',u('addAction')));
 card.append(desc,node('span','zp-game-plus','+'));return card;
}

function groupOf(label){
 const s=String(label||'').toLocaleLowerCase('pl-PL');
 if(/butelk|bidon|woda na spacer|wodę i karmę|saszetka na smakołyki/.test(s))return 'walk';
 if(/tacka do lizania/.test(s))return 'food';
 if(/mata do drapania|kliker/.test(s))return 'play';
 if(/mata chłodząca/.test(s))return 'sleep';
 if(/apteczk|rękawic|mata pod kuwetę/.test(s))return 'care';
 if(/przysmak|smako|smak\b|przekąsk|nagrod|karma|gryzak/.test(s))return 'food';
 if(/zabaw|piłk|wędka|drapak/.test(s))return 'play';
 if(/smycz|obroż|szelk|adresówk|woreczk|pojemnik|płaszczyk|transporter|transp\b/.test(s))return 'walk';
 if(/legowisk|posłani|kocyk|budka|schronieni|kryjówka/.test(s))return 'sleep';
 if(/szczotk|grzebie|łap|szampon|kuwet|żwirek|podkład|preparat|obcinaczk|miska|mat[ay]/.test(s))return 'care';
 return 'other';
}
function filterBar(p){
 const bar=node('div','zp-game-filter-bar');
 bar.append(node('span','zp-game-filter-caption',u('filterCaption')));
 for(const [name,label] of [['all',u('filterAll')],['food',u('filterFood')],['play',u('filterPlay')],['walk',u('filterWalk')],['sleep',u('filterSleep')],['care',u('filterCare')],['other',u('filterOther')]]){
  if(name!=='all'&&!p.slots.some(s=>groupOf(s.title)===name))continue;
  const b=btn(label,'zp-game-filter'+(activeFilter===name?' selected':''),()=>{activeFilter=name;draw()});
  b.setAttribute('aria-pressed',String(activeFilter===name));bar.append(b);
 }
 return bar;
}
function renderBoard(p){
 const panel=node('section','zp-game-board');
 const topper=node('div','zp-game-board-head');
 topper.append(node('div','zp-game-head-copy'));
 topper.children[0].append(node('span','zp-game-eyebrow',u('boardEyebrow')),node('h2','',p.showName),node('p','',u('boardHint')));
 topper.append(node('span','zp-game-doodle','✦'));
 panel.append(topper,filterBar(p));
 const desk=node('div','zp-game-desk'),picked=picks(p).filter(x=>activeFilter==='all'||groupOf(x.slot.title)===activeFilter);
 picked.forEach((entry,i)=>desk.append(productCard(p,entry,i)));
 if(!picked.length)desk.append(node('p','',u('emptyBoard')));
 panel.append(desk);
 const optionals=p.slots.map((s,i)=>({s,i})).filter(x=>x.s.options.some(sku=>dict[sku]&&(dict[sku]._live?dict[sku]._available:dict[sku]._availableFromAudit!==false))&&choices(p,x.i).length===0&&(activeFilter==='all'||groupOf(x.s.title)===activeFilter));
 if(optionals.length){
  const addons=node('section','zp-game-addons');
  addons.append(node('div','zp-game-addon-heading'));
  addons.children[0].append(node('span','zp-game-eyebrow',u('addonsEyebrow')),node('h3','',u('addonsTitle')),node('p','',u('addonsHelp')));
  const tray=node('div','zp-game-tray');optionals.forEach(x=>tray.append(addOnCard(p,x.i)));addons.append(tray);panel.append(addons);
 }
 if(p.checklist?.length){
  const more=node('details','zp-game-checklist'),summary=node('summary','',u('checklistTitle'));more.append(summary);
  const list=node('ul');p.checklist.forEach(x=>list.append(node('li','',x.text)));more.append(list);panel.append(more);
 }
 return panel;
}
function renderFooter(p){
 const footer=node('div','zp-game-footer'),left=node('div','zp-game-total');
 left.append(node('span','',u('totalLabel')),node('strong','',fmt(Math.round(total(p)*100)/100)));
 footer.append(left);
 const chosen=picks(p);
 const pending=chosen.some(x=>!dict[x.sku]?._live),unavailable=chosen.some(x=>dict[x.sku]?._live&&!dict[x.sku]?._available),invalid=exactProblem(p);
 const purchase=btn(busy?u('cartBusy'):pending?u('cartChecking'):unavailable?u('cartUnavailable'):invalid?u('cartInvalid'):u('buyLabel'),'zp-game-cart',()=>addCart(p));
 purchase.disabled=busy||!!invalid||pending||unavailable||!chosen.length;
 footer.append(purchase);
 if(notice){const alert=node('p','zp-game-notice',notice);alert.setAttribute('role','alert');footer.append(alert);}
 footer.append(node('small','zp-game-cart-info',u('footerInfo')));
 return footer;
}
function draw(){
 const p=current();root.replaceChildren();
 const main=node('div','zp-game-app');
 const heading=node('div','zp-game-heading');
 heading.append(node('span','zp-game-eyebrow',u('pageEyebrow')),node('h2','',merchant.heading||'Wybierz pakę. Reszta to zabawa.'),node('p','',merchant.subtitle||'Odkrywaj produkty, wymieniaj i dorzucaj to, czego potrzebuje Twój pupil.'));
 main.append(heading);
 const tabs=node('div','zp-game-tabs');
 [['pies',u('dogTab')],['kot',u('catTab')]].forEach(([k,label])=>{
  const b=btn(label,'zp-game-tab'+(species===k?' is-selected':''),()=>{
   if(species===k)return;species=k;activeFilter='all';
   const next=packs.find(p=>p.species===k);
   if(next){key=next.key;history.replaceState(null,'',location.pathname+location.search+'#'+key)}
   notice='';closeModal(false);draw();syncCurrent();
  });
  b.setAttribute('aria-pressed',String(species===k));tabs.append(b);
 });
 main.append(tabs);
 const options=node('div','zp-game-pack-grid');
 packs.filter(p=>p.species===species).forEach(p=>options.append(packTile(p)));
 main.append(options,renderBoard(p),renderFooter(p));root.append(main);
}
function closeModal(refocus=true){
 if(!modal)return;const a=modal;modal=null;a.overlay.remove();
 if(refocus&&a.trigger?.isConnected&&a.trigger.focus)a.trigger.focus();
}
function makeOverlay(title,type){
 const focus=document.activeElement;
 closeModal(false);
 const overlay=node('div','zp-game-overlay');overlay.setAttribute('role','presentation');
 const box=node('section','zp-game-dialog zp-game-dialog-'+type);
 box.setAttribute('role','dialog');box.setAttribute('aria-modal','true');box.setAttribute('aria-label',title);
 const top=node('header','zp-game-dialog-header');
 top.append(node('h2','',title),btn('×','zp-game-dialog-close',()=>closeModal()));
 box.append(top);overlay.append(box);
 overlay.addEventListener('click',e=>{if(e.target===overlay)closeModal()});
 document.body.append(overlay);
 modal={overlay,box,trigger:focus,type};
 box.querySelector('.zp-game-dialog-close')?.focus();
 return box;
}
function openPreview(p,i,sku){
 const d=dict[sku];if(!d)return;
 const box=makeOverlay(u('previewTitle'),'preview');
 const container=node('div','zp-game-preview-content');
 container.append(image(sku,'zp-game-preview-image'));
 const info=node('div','zp-game-preview-info');
 info.append(node('span','zp-game-eyebrow',p.slots[i].title),node('h3','',d.name),node('strong','zp-game-preview-price',fmt(d.price)));
 const availability=node('p','zp-game-availability',d._live?(d._available?u('available'):u('unavailable')):u('loading'));
 info.append(availability);
 if(d._description)info.append(node('p','zp-game-preview-description',d._description));
 const actions=node('div','zp-game-preview-actions');
 if(d.handle){const a=node('a','zp-game-view-link',u('fullDescription'));a.href=shopRoot+'products/'+encodeURIComponent(d.handle);a.target='_blank';a.rel='noopener noreferrer';actions.append(a)}
 const change=btn(u('previewSelect'),'zp-game-modal-action',()=>openChooser(p,i,choices(p,i).some(x=>x.sku===sku)?sku:null));actions.append(change);
 info.append(actions);container.append(info);box.append(container);
 loadSku(sku).then(()=>{if(modal?.box===box){if(!d._available)availability.textContent=u('unavailable');else availability.textContent=u('available');if(!info.querySelector('.zp-game-preview-description')&&d._description)info.insertBefore(node('p','zp-game-preview-description',d._description),actions)}});
}

function openChooser(p,i,originalSku=null){
 const slot=p.slots[i],sized=Boolean(slot.sized),box=makeOverlay(u('chooserPrefix')+slot.title,'chooser');
 box.append(node('p','zp-game-chooser-lead',u('chooserHelp')));
 if(sized)box.append(node('p','zp-game-size-help',u('sizeHint')));
 const currentBox=node('div','zp-multi-current');
 const area=node('div','zp-game-choice-grid'),label=node('p','zp-game-choice-notice','');
 const search=node('input','zp-game-choice-search');search.type='search';search.placeholder='Szukaj produktu, marki lub rozmiaru…';search.setAttribute('aria-label','Szukaj dostępnego produktu');

 if(slot.options.length>=7)box.append(search);
 box.append(currentBox,area,label);
 const families=[...new Set(slot.options.map(sku=>dict[sku]?.family||'Inne'))];
 const buttons=[];
 function updateVisible(){
  const typed=(search.value||'').toLocaleLowerCase('pl-PL').trim();
  let count=0;
  buttons.forEach(({tile,sku})=>{
   const item=dict[sku];
   const matching=!typed||String(item?.name||'').toLocaleLowerCase('pl-PL').includes(typed)||String(item?.size||'').toLocaleLowerCase('pl-PL').includes(typed)||String(item?.family||'').toLocaleLowerCase('pl-PL').includes(typed);
   tile.hidden=Boolean(!matching||!item?._live||!item._available);
   if(!tile.hidden)count++;
  });
  area.children.forEach(section=>{const grid=section.querySelector('.zp-game-choice-tiles');if(grid)section.hidden=grid.children.every(tile=>tile.hidden)});
  const loaded=buttons.every(({sku})=>dict[sku]?._live);
  if(!count)label.textContent=loaded?'Brak dostępnych produktów spełniających kryteria.':u('chooserChecking');
  else if(label.textContent==='Brak dostępnych produktów spełniających kryteria.'||label.textContent===u('chooserChecking'))label.textContent='';
 }
 search.oninput=updateVisible;
 function redrawCurrent(){
  currentBox.replaceChildren(node('strong','zp-multi-current-heading',u('chosenHeading')));
  const items=choices(p,i);
  if(!items.length)currentBox.append(node('p','zp-multi-empty',u('chosenEmpty')));
  items.forEach(x=>{
   const line=node('div','zp-multi-line');
   line.append(image(x.sku,'zp-multi-line-img'));
   const title=node('span','zp-multi-line-name',dict[x.sku]?.name||x.sku);
   line.append(title);
   const minus=btn('−','zp-multi-small',()=>{alterQty(p,i,x.sku,-1);redrawCurrent();refreshButtons()});
   minus.disabled=x.qty<=1;minus.setAttribute('aria-label','Zmniejsz ilość '+title.textContent);
   const plus=btn('+','zp-multi-small',()=>{alterQty(p,i,x.sku,1);redrawCurrent();refreshButtons()});
   plus.disabled=x.qty>=perProductLimit;plus.setAttribute('aria-label','Zwiększ ilość '+title.textContent);
   line.append(node('strong','zp-multi-line-subtotal',fmt(Math.round((dict[x.sku]?.price||0)*x.qty*100)/100)),minus,node('span','zp-multi-count',String(x.qty)),plus);
   line.append(btn(u('removeAction'),'zp-multi-remove',()=>{persist(p,i,choices(p,i).filter(v=>v.sku!==x.sku));redrawCurrent();refreshButtons()}));
   currentBox.append(line);
  });
  currentBox.append(node('small','zp-multi-tip',interpolate(u('chosenLimits'),{different:multiLimit,pieces:perProductLimit})));
 }
 function refreshButtons(){
  if(modal?.box!==box)return;
  const selected=choices(p,i);
  buttons.forEach(({sku,add,change,status,tile})=>{
   const d=dict[sku],currentEntry=selected.find(x=>x.sku===sku),amount=currentEntry?.qty||0;
   status.textContent=!d._live?u('sizeChecking'):(d._available?u('sizeAvailable'):u('sizeUnavailable'));
   tile.className='zp-game-choice'+(d._live&&!d._available?' zp-game-unavailable':'');
   if(sized)tile.setAttribute('aria-label',d.name+' — '+status.textContent);
   add.disabled=!d._live||!d._available||amount>=perProductLimit||(selected.length>=multiLimit&&!currentEntry);
   add.textContent=amount>=perProductLimit?u('chooserLimit'):(amount?u('chooserAnother'):u('chooserAdd'));
   if(change){
    change.disabled=!d._live||!d._available||sku===originalSku;
    change.textContent=sku===originalSku?u('chooserCurrent'):u('chooserReplace');
   }
  });
 }
 async function choose(sku,mode){
  if(modal?.box!==box)return;
  label.textContent=u('chooserChecking');
  const product=await loadSku(sku,true);
  if(modal?.box!==box)return;
  if(!product?._available){label.textContent=u('chooserUnavailable');refreshButtons();return}
  const result=addChoice(p,i,sku,mode,originalSku);
  if(!result){label.textContent=u('chooserMax');refreshButtons();return}
  if(mode==='replace')originalSku=sku;
  label.textContent=mode==='replace'?u('chooserReplaced'):u('chooserAdded');
  redrawCurrent();refreshButtons();
 }
 families.forEach(family=>{
  const section=node('section','zp-game-family');
  section.append(node('h3','',family==='Inne'?u('chooserFamily'):family));
  const grid=node('div','zp-game-choice-tiles');
  slot.options.filter(sku=>(dict[sku]?.family||'Inne')===family).forEach(sku=>{
   const d=dict[sku];if(!d)return;
   const tile=node('div','zp-game-choice'),photo=btn('','zp-game-choice-image',()=>openPreview(p,i,sku));tile.hidden=true;
   photo.setAttribute('aria-label','Podgląd '+d.name);photo.append(image(sku,''));
   const summary=node('div','zp-game-choice-copy');
   summary.append(node('strong','',d.sized&&d.size?d.size:d.size?d.family+' · '+d.size:d.name),node('small','',fmt(d.price)));
   const stockLabel=node('span','zp-game-variant-stock',u('sizeChecking'));
   if(sized)summary.append(stockLabel);
   const add=btn(u('chooserAdd'),'zp-game-choice-select',()=>choose(sku,'add'));
   const change=originalSku?btn(u('chooserReplace'),'zp-multi-replace',()=>choose(sku,'replace')):null;
   tile.append(photo,summary,add);if(change)tile.append(change);
   grid.append(tile);buttons.push({tile,sku,add,change,status:stockLabel});
   loadSku(sku).then(v=>{if(modal?.box===box){if(v)summary.children[1].textContent=fmt(v.price);refreshButtons();updateVisible()}});
  });
  section.append(grid);area.append(section);
 });
 box.append(btn(u('chooserDone'),'zp-multi-done',()=>closeModal()));
 redrawCurrent();refreshButtons();updateVisible();
}
async function addCart(p){
 if(busy)return;
 const chosen=picks(p);if(!chosen.length||exactProblem(p))return;
 busy=true;notice='';draw();
 try{
  await Promise.all(chosen.map(x=>loadSku(x.sku,true)));
  const missing=chosen.filter(x=>!dict[x.sku]?._available||!dict[x.sku]?.variantId);
  if(missing.length)throw Error(u('cartOutOfStock')+missing.map(x=>x.slot.title).join(', '));
  const id=p.key+'-'+Date.now().toString(36)+'-'+Math.random().toString(36).slice(2,7);
  const merged=new Map();
  chosen.forEach(x=>{
   const variantId=dict[x.sku].variantId;
   if(merged.has(variantId))merged.get(variantId).quantity+=x.qty;
   else merged.set(variantId,{id:variantId,quantity:x.qty,properties:{'Paka ZOOPLICITY':p.showName,'_zp_bundle_ref':id}});
  });
  const response=await fetch(shopRoot+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[...merged.values()]})});
  const out=await response.json().catch(()=>({}));
  if(!response.ok)throw Error(out.description||out.message||u('cartError'));
  window.location.assign(shopRoot+'cart');
 }catch(err){notice=String(err.message||err);busy=false;draw();}
}
document.addEventListener('keydown',e=>{
 if(e.key==='Escape'&&modal){e.preventDefault();closeModal()}
 if(e.key==='Tab'&&modal){
  const focus=modal.box.querySelectorAll('button:not([disabled]),a[href],input:not([disabled])');
  if(!focus.length)return;
  const first=focus[0],last=focus[focus.length-1];
  if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus()}
  else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}
 }
});
draw();syncCurrent();
};
if(!window.__zpPakiEditorBound){
 document.addEventListener('shopify:section:load',event=>{
  if(event.target?.querySelector?.('[data-zp-paki-lab-app]'))window.ZP_PAKI_BOOT?.();
 });
 window.__zpPakiEditorBound=true;
}
window.ZP_PAKI_BOOT();